module.exports = __webpack_public_path__ + "static/img/projectService_1.0d3503a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectService_1.jpg
// module id = bUS1
// module chunks = 0